<div class="dealer-card margin all">
  <mat-card class="padding all">
    <mat-card-header class="static header-container">
      <mat-card-title>Dealer KeySystem</mat-card-title>
          <!-- <phx-button
          class="margin left"
          [color]="'#393E46'"
          [small]="true"
          [disabled]="loading.isLoading || disableUpdate || isUpdatingSystem"
          (click)="resetDealerKeySystem()"
        >
          <span> Reset </span>
        </phx-button> -->
        <!-- <phx-button
          class="margin left"
          [color]="'#393E46'"
          [small]="true"
          [disabled]="loading.isLoading || disableUpdate || isUpdatingSystem"
          (click)="updateDealerKeySystem()"
        >
          <span> Update </span>
        </phx-button> -->
      <p *ngIf="hasUnsavedChanges()" class="warning padding">
        The form contains unsaved changes
      </p>
      <div class="flex-end">
        <input
          type="file"
          #file
          id="file-upload"
          accept=".csv"
          (change)="importFile($event.target.files)"
        />
        <button
          class="margin all"
          mat-icon-button
          color="primary"
          (click)="file.click()"
        >
          <mat-icon class="no-margin">import_export</mat-icon>
        </button>
        <button
          mat-raised-button
          class="margin all"
          color="primary"
          (click)="saveDealerSpec()"
          [disabled]="saveDisabled"
          (document:keydown.control.s)="saveDealerSpec($event)"
        >
          Save
        </button>
        <button
          mat-raised-button
          class="margin all"
          color="primary"
          (click)="saveAndContinueDealerSpec()"
          [disabled]="saveAndContinueDisabled"
        >
          Save & Continue
        </button>
      </div>
    </mat-card-header>
    <lib-hierarchy
      [showDealerMasterKeyTree]="true"
      [masterKeys]="keySystem?.masterKeysKeying"
      [keyways]="keyways"
      [keySystem]="keySystem"
      [structure]="structure"
      [heightOffset]="100"
      [dealerMasterKeys]="dealerMasterKeys"
      [@fadeIn]
      (patchItemAction)="patchItem($event)"
      (dealererror)="handleDealerError($event)"
    >
    </lib-hierarchy>
  </mat-card>
</div>